<template>
    <div>
      <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading" >
        <div class="header">
          <div class="back" @click="$router.back()">返回</div>
          <div class="title">发布政策</div>
        </div>
        <div class="import-title">
          <span class="cost-title-list-txt">基础信息</span>
        </div>
        <div class="customer-information">
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span>*</span>标题</div>
                <el-input size="small" class="w260" maxlength="50"  placeholder="最多可输入50个字" v-model="form.medicinePolicyTitle"></el-input>
              </div>
              <div class="col-itms second">
                <div class="title"><span>*</span>政策分类</div>
                <el-select size="small" class="ipt-sty w260" multiple  v-model="form.contentCategoryGuids" placeholder="请选择">
                  <el-option v-for="item in tagList" :key="item.guid" :label="item.categoryName" :value="item.guid">
                  </el-option>
                </el-select>
              </div>
            </div>
        </div>
        <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span>*</span>编号</div>
                <el-input
                 size="small" class="w260" maxlength="8"  placeholder="最多8位数字" v-model="form.medicinePolicyCode" 
                 @input="form.medicinePolicyCode = form.medicinePolicyCode.replace(/[^\d\-\d]/g, '')"
                v-model.trim="form.medicinePolicyCode"></el-input>
              </div>
              <div class="col-itms second">
                <div class="title"><span>*</span>关键词</div>
                <el-input size="small" class="w260" maxlength="100"  placeholder="最多可输入100个字，多个关键词顿号分割" v-model="form.medicinePolicyKeyword"
                ></el-input>
                
              </div>
            </div>
        </div>
          
          <!-- 政策内容 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span>*</span>政策内容</div>
                <el-input
                    class="w640"
                    type="textarea"
                    :rows="5"
                    maxlength="2000"
                    show-word-limit
                    placeholder="请输入"
                    v-model="form.policyContent"
                  >
                  </el-input>
              </div>
            </div>
          </div>
          <!-- 政策解读 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span> </span>政策解读</div>
                <el-input
                    class="w640"
                    type="textarea"
                    :rows="5"
                    maxlength="5000"
                    show-word-limit
                    placeholder="请输入"
                    v-model="form.policyInterpret"
                  >
                  </el-input>
              </div>
            </div>
          </div>
          <!-- 发布方 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span>*</span>发布方</div>
                <el-input
                    class="w640"
                    type="textarea"
                    :rows="3"
                    maxlength="200"
                    show-word-limit
                    placeholder="请输入"
                    v-model="form.publishName"
                    
                  >
                  </el-input>
              </div>
            </div>
          </div>
          <!-- 政策发布日期 -->
          <div class="cols">
            
            <div class="col-itms">
              <div class="title"><span>*</span>发布日期</div>
              <el-date-picker
                v-model="form.publishDate"
                type="date"
                :picker-options="expireTimeOption"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>
          <!-- 上架状态 -->
          <div class="import-new-wrap">
            <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>上架状态</div>
              <el-radio-group class="w300 content-left" v-model="form.bizState">
                <el-radio label="1">上架</el-radio>
                <el-radio label="2">下架</el-radio>
              </el-radio-group>
            </div>
          </div>
          </div>
       
        <div class="operte-btns">
          <div class="btn cancel" @click="$router.back()">取消</div>
  
          <div  class="btn submit" @click="saveReq">发布</div>
          <div v-if="!guid" class="btn submit" @click="saveReq(1)">发布下一个</div>
        </div>
      </div>
    </div>
   
    </div>
  </template>
  
  <script>
  export default {
    components: {},
    data() {
      return {
        tagList:[],//内容分类
        
        
        fullscreenLoading: false,
        
        guid: '',
        form: {
          guid:'',//系统唯一标识
          medicinePolicyTitle:'',//标题
          contentCategoryGuids:[],// 内容分类GUID，[‘guid1’,’guid2’]
          medicinePolicyCode:null,//编号
          medicinePolicyKeyword:'',//关键词
          policyContent:'',// 政策内容
          policyInterpret:'',// 政策解读
          publishName:'',// 发布方
          publishDate:new Date(),//发布日期
          bizState:'1',// 上架状态(1 上架, 2 下架)
        },
        coverPhotoAttach: [],
        fileSize: serverConfig.FILE_SIZE,
        restaurants: [],
        expireTimeOption:{
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6
          }
        }//时间限制当天以前可选
      };
    },
   
    
    created() {
      if(this.$route.query.guid){
        this.guid=this.$route.query.guid
        this.getDetail();
      }
      this.getContentCategory()
      
    },
    methods: {
      getDetail() {
        let that = this;
        console.log('this.$route',this.$route);
        that.api.get(`/${serverConfig.msProductService}/medicine-policy/detail/${that.guid}`).then((res) => {
          
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
            this.form = res.data.data
            
          } else {
            that.$message.error(res.data.msg);
          }
        });
      },
      
      
      //提交申请
      saveReq(type) {
        if (!this.checkForm()) {
          return;
        }
        let form = JSON.parse(JSON.stringify(this.form));
        
        let reqUrl;
        let method;
        let message;
        
        if (this.guid) {
          reqUrl = `/${serverConfig.msProductService}/medicine-policy/update`;
          form.guid = this.guid;
          method='put'
          message='修改成功'
        } else {
          reqUrl = `/${serverConfig.msProductService}/medicine-policy/add`;
          form.guid = null;
          method='postJson'
          message='新增成功'
        }
        this.fullscreenLoading = true;
        this.api[method](reqUrl, form).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: message,
              type: 'success',
            });
            if(type==1){
              // 添加下一个，数据清空
              this.form={
                guid:'',//系统唯一标识
                medicinePolicyTitle:'',//标题
                contentCategoryGuids:[],// 内容分类GUID，[‘guid1’,’guid2’]
                medicinePolicyCode:null,//编号
                medicinePolicyKeyword:'',//关键词
                policyContent:'',// 政策内容
                policyInterpret:'',// 政策解读
                publishName:'',// 发布方
                publishDate:new Date(),//发布日期
                bizState:'1',// 上架状态(1 上架, 2 下架)
              }
            }else{
              this.$router.go(-1);
            }
            
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      
      // 获取内容分类
      getContentCategory(){
        let that=this
        let req = {
          pageIndex:1,
          pageSize:-1,
          categoryType:2
        };
        
        that.api.postJson(`/${serverConfig.msProductService}/content-category/list`, req).then((res) => {
          
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.tagList = res.data.data.records;
          } else {
            that.$message.error(res.data.msg);
          }
        });
      },
     
      
      checkForm() {
        if (!this.form.medicinePolicyTitle) {
          this.$message.error('标题不能为空');
          return false;
        }
        if (!this.form.contentCategoryGuids.length) {
          this.$message.error('政策分类不能为空');
          return false;
        }
        if (!this.form.medicinePolicyCode) {
          this.$message.error('编号不能为空');
          return false;
        }
        if (!this.form.medicinePolicyKeyword) {
          this.$message.error('关键词不能为空');
          return false;
        }
        if (!this.form.policyContent) {
          this.$message.error('政策内容不能为空');
          return false;
        }
        if (!this.form.publishName) {
          this.$message.error('发布方不能为空');
          return false;
        }
        if (!this.form.publishDate) {
          this.$message.error('发布日期不能为空');
          return false;
        }
        if (!this.form.bizState) {
          this.$message.error('上架状态不能为空');
          return false;
        }
        
        
        return true;
      },
     
     
    },
  };
  </script>
  
  <style lang="less" scoped>
  /deep/.el-input-number__decrease {
    display: none;
  }
  /deep/.el-input-number__increase {
    display: none;
  }
  /deep/ .el-input-number .el-input__inner {
    text-align: left;
    padding-left: 15px;
  }
  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }
  
  .flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
  }
  
  .pdt100 {
    padding-bottom: 100px !important;
  }
  
  .header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
  
  .header .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
  
  .import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
    position: relative;
  }
  
  .empty-tooltip {
    background: #fff;
    font-size: 16px;
    padding: 25px 0;
  }
  
  .import-title.second {
    margin-top: 4px;
  }
  
  .header .title {
    text-align: center;
    flex: 1;
  }
  
  .customer-information {
    background: #fff;
    padding-bottom: 15px;
  }
  
  .customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    line-height: 28px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  
  .sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
  }
  
  .sub-operate-add2 {
    color: #4fa1a4;
    font-size: 14px;
    margin-left: 14px;
    cursor: pointer;
    position: absolute;
    right: 35px;
    top: 10px;
    text-align: center;
  }
  
  .sub-operate-del {
    font-size: 14px;
    color: #4fa1a4;
    cursor: pointer;
    text-align: center;
    margin: 0 20px;
  }
  
  .customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
  }
  
  .customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  
  .customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
  }
  
  .customer-information .col-itms.second {
    margin-left: 170px;
  }
  
  .customer-information .col-itms .title span {
    color: red;
  }
  .w640{
    width:640px
  }
  .import-new-wrap {
    padding-bottom: 15px;
  }
  
  .import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 10px;
    color: #666;
    font-size: 12px;
  }
  
  .import-new-wrap .col-itms {
    align-items: baseline;
  }
  
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }
  
  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .operte-btns .btn.save {
    border: 1px solid #4FA1A4;
    color: #4FA1A4;
    cursor: pointer;
  }
  
  .operte-btns .btn.submit {
    border: 1px solid #4FA1A4;
    background: #4FA1A4;
    color: #fff;
    cursor: pointer;
  }
  .file-operate {
    display: flex;
    margin-top: 5px;
  }
  .file-preview {
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
  }
  .bank-content {
    text-align: left;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
  }
  .bank-info {
    color: #a7a7a7;
  }
  
  .content-left {
    text-align: left;
  }
  .btn-upload {
    width: 84px;
    height: 28px;
    padding: 0;
  }
  .icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 180px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
  
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 80px;
  height: 80px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 80px;
}

.img-close {
  position: relative;
  float: left;
  width: 80px;
  height: 80px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
  </style>
  <style>
  .cols-content{
      
      .el-textarea{
        width:840px
      }
    }
  .icon-dialog-wrap .el-dialog__body {
    padding: 0;
    padding-top: 10px;
  }
  #template-config .el-dialog {
      /* height: 80vh; */
      overflow: auto;
  }
  #template-config .el-form-item__content{
    margin-left:15px !important;
    display: flex;
  }
  #template-config .el-form-item{
    align-items:flex-start;
  }
  #template-config .calc-type .el-form-item__label{
    line-height:15px;
  }
  .el-table .cell{
    white-space: nowrap;
  }
    .el-input__inner{
      padding: 0 8px;
    }
    .detail-class .el-table__row{
      height: 12px;
      line-height: 12px;
    }
    .el-collapse-item__header {
      padding-left: 15px;
    }
    
    .el-upload--picture-card {
      float: left;
      margin-right: 10px;
    }
    
    .circle-closesty {
      position: relative;
      top: -35px;
      margin-left: 112px;
      font-size: 20px;
      cursor: pointer;
    }
    
    .v-modal {
      z-index: 100 !important;
    }
    
    .select-box {
      overflow: hidden;
      margin: 0 0px 10px 30px;
    }
    
    .box-left {
      width: 40%;
      height: 350px;
      padding: 0 20px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
      overflow-y: auto;
    }
    
    .box-right {
      width: 57%;
      height: 350px;
      padding: 0 10px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
    }
    
    .field-radio {
      display: flex;
      align-items: center;
    }
    
    .field-radio .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-form-item {
      margin-bottom: 18px;
    }
    
    .other-config {
      display: flex;
      font-size: 14px;
      padding-left: 50px;
      /* padding-top: 30px; */
    }
    
    .other-content {
      flex: 1;
    }
    
    .other-content-list {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    
    .other-title {
      padding-right: 10px;
    }
    
    /* 报货配置 */
    .bh-config-box {
      display: flex;
      height: 40px;
      align-items: center;
      font-size: 14px;
      padding-left: 50px;
      padding-top: 10px;
    }
    
    .bh-config-title {
      margin-right: 10px;
    }
    
    /* 库存信息采集 */
    .kc-label {
      font-size: 12px;
      color: #86909c;
    }
    
    .kc-label span {
      color: #4fa1a4;
      cursor: pointer;
    }
    
    .kc-box {
      padding: 16px;
      box-sizing: border-box;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
      color: #323232;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #323232;
    }
    .el-tabs__item.is-active{
      color: #4fa1a4;
    }
    .kc-box .el-tabs__item {
      border-right: 1px solid #dcdfe6 !important;
    }
    
    .kc-tab-box {
      height: 340px;
      padding: 0 0 40px;
      font-size: 14px;
      overflow-y: auto;
      box-sizing: border-box;
    }
    
    .kc-tab-list {
      padding: 0 0 40px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdcdc;
    }
    
    .kc-tab-list:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
    
    .kc-tab-label {
      display: flex;
      margin-top: 30px;
    }
    
    .label-left-name img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    
    .tab-label-left {
      width: 350px;
      display: flex;
      margin-right: 20px;
    }
    
    .label-left-name {
      width: 100px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      flex-shrink: 0;
    }
    
    .tab-label-right {
      display: flex;
      align-items: center;
      color: #c8c8c8;
    }
    
    .tab-label-add {
      color: #4fa1a4;
      cursor: pointer;
      margin-right: 10px;
    }
    
    .tab-label-del {
      color: #d0021b;
      cursor: pointer;
      margin: 0 10px;
    }
    
    .kc-tab-rules {
      display: flex;
      margin-top: 16px;
    }
    
    .kc-rules-center {
      display: flex;
      align-items: center;
    }
    
    .rules-center-input span {
      margin: 0 8px;
    }
    
    .kc-no-label {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .kc-no-label img {
      width: 213px;
      margin-right: 35px;
    }
    
    .no-label-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    
    .no-label-text h3 {
      font-size: 18px;
      color: #7f828f;
      text-align: left;
      font-weight: 500;
      margin: 0;
    }
    
    .no-label-text p {
      font-size: 14px;
      color: #7f828f;
      line-height: 20px;
      margin: 6px 0 13px;
      text-align: left;
    }
    
    .no-label-btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      text-align: center;
      color: #4fa1a4;
      cursor: pointer;
      border: 1px solid #4fa1a4;
    }
    
    .dy-table {
      width: 800px;
      margin-left: 10px;
    }
    
    .dy-table .dy-table-title {
      display: flex;
      height: 60px;
      line-height: 60px;
      background: #f2f2f2;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table .dy-table-title div {
      width: 200px;
    }
    
    .dy-table .dy-table-item {
      display: flex;
      height: 50px;
      align-items: center;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table-item-label {
      width: 200px;
      flex-shrink: 0;
      text-align: center;
    }
    
    .dy-table .dy-radio-box {
      width: 200px !important;
      text-align: center;
    }
    
    .dy-config-wrap {
      display: flex;
      font-size: 14px;
      margin: 30px 0;
      padding-left: 50px;
    }
    
    .dy-config-title {
      flex-shrink: 0;
      margin-top: 20px;
    }
    
    .product-select-all {
      margin-bottom: 20px;
    }
    .title-content {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      width: 100%;
    }
    .title-item {
      vertical-align: middle;
      text-align: center;
      padding-right: 10px;
    }
    .left-text {
      text-align: left;
    }
    .w200 {
      width: 30%;
    }
    .w160 {
      width: 160px;
    }
    .w260 {
      width: 200px;
    }
    .w100 {
      width: 100px;
    }
    .configure-fields {
      width: 760px !important;
    }
    .configure-fields .el-dialog__body {
      overflow-y: auto;
      max-height: 600px;
    }
    .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /* 选项内容样式 */
    .select-content-box {
      width: 92%;
      margin: 0 0px 10px 30px;
    }
    .select-content {
      width: 100%;
      /* padding:0 10px; */
      background: #fafafa;
      border: 1px solid #e5e5e5;
    }
    .el-form-item__label {
      color: #666;
    }
    .select-content .el-form-item__label {
      width: 90px !important;
    }
    .select-content .el-form-item__content {
      margin-left: 90px !important;
    }
    .config-item .el-form-item__content {
      margin-left: 0px !important;
    }
    /*  */
    .max-value {
      position: relative;
      height: 40px;
    }
    .max-value .el-input-number--mini {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 104px;
    }
  </style>
  
  